module.exports = __webpack_public_path__ + "static/media/vas-organizar-un-evento.8f3394ec.png";